import React from 'react';
import ReactDOM from 'react-dom/client';
// eslint-disable-next-line
import reportWebVitals from './reportWebVitals';
import 'app/assets/sass/index.scss';
import { Provider } from 'react-redux';
import { HistoryRouter as Router } from 'redux-first-history/rr6';
import * as Sentry from '@sentry/react';
import { envConfig } from 'common/config';
import { initAxios } from 'common/helpers/axios.helper';
import { initYandexMetrika } from 'common/yandexMetrika';
import { App } from 'app/App';
import { history, store } from 'app/store';

// Sentry initialization
Sentry.init({
  dsn: envConfig.SENTRY_DSN,
  environment: envConfig.NODE_ENV,
  ignoreErrors: ['ResizeObserver loop limit exceeded', 'TokenExpiredError', 'NetworkError'],
});

// @ts-ignore
window.checkSentry = (text?: string) => {
  const msg = `Sentry successfully connected. Config: ${JSON.stringify(envConfig)} ${new Date()}. Test string: ${text}`;
  console.log('Go to slack channel and check an error with message: ');
  console.log(msg);
  Sentry.captureException(msg);
};

initAxios();
initYandexMetrika();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={store}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
